import { render, staticRenderFns } from "./addLead.vue?vue&type=template&id=8fd306fc&scoped=true&"
import script from "./addLead.vue?vue&type=script&lang=js&"
export * from "./addLead.vue?vue&type=script&lang=js&"
import style0 from "./addLead.vue?vue&type=style&index=0&id=8fd306fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd306fc",
  null
  
)

export default component.exports